module.exports = {
	"name": "graylog-web-interface",
	"version": "2.1.0-SNAPSHOT",
	"description": "Graylog Web Interface",
	"author": "torch",
	"license": "GPL-3.0",
	"repository": {
		"type": "git",
		"url": "git://github.com/graylog2/graylog2-web-interface.git"
	},
	"readme": "../README.md",
	"scripts": {
		"start": "./node_modules/.bin/webpack --config webpack.vendor.js && ./node_modules/.bin/webpack-dev-server --config webpack.combined.config.js",
		"start-nohmr": "./node_modules/.bin/webpack --config webpack.vendor.js && ./node_modules/.bin/webpack-dev-server --watch --config webpack.combined.config.js",
		"build": "./node_modules/.bin/webpack -p --config webpack.vendor.js && ./node_modules/.bin/webpack",
		"test": "./node_modules/.bin/webpack --config webpack.vendor.js && ./node_modules/karma/bin/karma start karma.ci.conf.js",
		"prepare-dev": "./tools/prepare-dev"
	},
	"dependencies": {
		"bluebird": "^2.10.2",
		"c3": "^0.4.11-rc4",
		"classnames": "^2.2.0",
		"clipboard": "^1.5.5",
		"crossfilter": "1.3.x",
		"d3": "<=3.5.0",
		"dc": "2.0.0-beta.19",
		"deep-equal": "^1.0.1",
		"graylog-web-plugin": "latest",
		"history": "^1.17.0",
		"immutable": "^3.7.5",
		"javascript-natural-sort": "^0.7.1",
		"jquery": "2.1.x",
		"jquery-ui": "1.12.x",
		"markdown": "^0.5.0",
		"md5": "^2.0.0",
		"moment": "2.14.1",
		"moment-duration-format": "1.3.0",
		"moment-timezone": "0.5.7",
		"numeral": "^1.5.3",
		"qs": "5.1.x",
		"react": "0.14.8",
		"react-addons-linked-state-mixin": "0.14.8",
		"react-addons-pure-render-mixin": "0.14.8",
		"react-addons-test-utils": "0.14.8",
		"react-bootstrap": "0.28.3",
		"react-day-picker": "^2.3.3",
		"react-dnd": "^2.0.2",
		"react-dnd-html5-backend": "^2.0.0",
		"react-dom": "0.14.8",
		"react-overlays": "^0.6.5",
		"react-router": "1.0.3",
		"react-router-bootstrap": "0.19.3",
		"react-select": "^0.8.2",
		"reflux": "0.2.13",
		"rickshaw": "^1.5.1",
		"sockjs-client": "1.1.x",
		"string": "^3.3.1",
		"superagent": "^1.4.0",
		"superagent-bluebird-promise": "^2.1.0",
		"toastr": "^2.1.2",
		"typeahead.js": "^0.11.1",
		"urijs": "^1.17.0"
	},
	"devDependencies": {
		"babel-core": "^5.8.25",
		"babel-eslint": "^4.1.6",
		"babel-loader": "^5.3.2",
		"babel-plugin-react-auto-display-name": "0.0.1",
		"babel-plugin-react-transform": "^1.1.1",
		"clean-webpack-plugin": "^0.1.3",
		"css-loader": "^0.23.0",
		"enzyme": "^2.0.0",
		"eslint": "^2.2.0",
		"eslint-config-graylog": "file:packages/eslint-config-graylog",
		"eslint-loader": "^1.0.0",
		"estraverse-fb": "^1.3.1",
		"extract-text-webpack-plugin": "^1.0.1",
		"file-loader": "^0.9.0",
		"glob": "^7.0.0",
		"html-webpack-plugin": "^1.7.0",
		"jasmine-core": "*",
		"json-loader": "^0.5.3",
		"karma": "^1.1.2",
		"karma-chrome-launcher": "*",
		"karma-html2js-preprocessor": "*",
		"karma-jasmine": "*",
		"karma-phantomjs-launcher": "*",
		"karma-webpack": "*",
		"less": "^2.5.3",
		"less-loader": "^2.2.1",
		"mocha": "^2.3.4",
		"phantomjs-prebuilt": ">=1.9",
		"react-hot-loader": "^1.3.0",
		"react-proxy-loader": "^0.3.4",
		"react-transform-hmr": "^1.0.1",
		"script-loader": "^0.7.0",
		"style-loader": "^0.13.0",
		"ts-loader": "^0.8.2",
		"typescript": "^1.6.2",
		"url-loader": "^0.5.6",
		"webpack": "^1.12.6",
		"webpack-dev-server": "^1.12.0",
		"webpack-merge": "^0.x.x"
	}
};


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/package.json
// module id = 452
// module chunks = 0